import config from "../../config";

/**
 * Auth0 configuration supplied by the local WorkUI configuration.
 *
 * @property domain Auth0 tenant domain (for example, `example.uk.auth0.com`).
 * @property clientId Auth0 SPA client ID.
 */
export interface Auth0Config {
  domain?: string;
  clientId?: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Type guard for the optional Auth0 config fields supported by WorkUI.
 */
function isAuth0ConfigSource(value: unknown): value is Auth0Config {
  if (!isRecord(value)) {
    return false;
  }

  if ("domain" in value && typeof value.domain !== "string") {
    return false;
  }

  if ("clientId" in value && typeof value.clientId !== "string") {
    return false;
  }

  return true;
}

function readOptionalConfigValue(value: unknown): string | undefined {
  const trimmedValue = typeof value === "string" ? value.trim() : undefined;
  return trimmedValue ? trimmedValue : undefined;
}

const rawConfig: unknown = config;
const configuredAuth0 = isRecord(rawConfig) && isAuth0ConfigSource(rawConfig.auth0) ? rawConfig.auth0 : undefined;

export const auth0Config: Auth0Config = {
  domain: readOptionalConfigValue(configuredAuth0?.domain),
  clientId: readOptionalConfigValue(configuredAuth0?.clientId),
};
